<template>
  <div>
    <div class="text-right">
      <v-btn
          color="success"
          class="mb-3 ml-3 px-0 white--text"
          elevation="0"
          min-width="36"
          min-height="36"
          @click="showAddForm = !showAddForm"
          :title="$t('common.add_new_car')"
          id="newCarBtn"
      >
        <v-icon small>$car_plus</v-icon>
      </v-btn>
      <v-progress-circular
        indeterminate
        color="primary"
        v-if="savingInProgress"
      ></v-progress-circular>
    </div>
    <slot name="customer"></slot>
    <v-form autocomplete="nope" v-show="showAddForm">
      <car-selector-by-api
          v-show="!tmpCar"
          :visibility-status="showAddForm"
          @selected="(data) => chooseCar(data)"
      />
      <div v-show="tmpCar">
        <strong v-if="tmpCar && tmpCar.name">
            <span v-if="tmpCar.name === ''">
              {{ tmpCar.brand }} {{ tmpCar.model }}</span
            >
          <span v-else> {{ tmpCar.name }}</span>
          <span v-if="tmpCar.vin"> VIN: {{ tmpCar.vin }}</span>
          <beauty-car-number
              class="d-inline-block ml-2"
              :number="tmpCar.car_number ? tmpCar.car_number : ''"
          />
          <v-btn icon color="warning" @click="tmpCar=null;selectedModificationProps = null" class="">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </strong>
      </div>
    </v-form>
    <v-data-table
      v-if="
        cars &&
        !showAddForm &&
        customerId
      "
      :headers="carsTableHeader"
      :items="cars"
      class="elevation-0 mb-3 xxx"
      :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          10, 50, 100,
          //-1
        ],
      }"
    >
      <template v-slot:footer.page-text="props">
        {{
          $t("tables.x_of_y", [
            `${props.pageStart}-${props.pageStop}`,
            props.itemsLength,
          ])
        }}
      </template>
      <template v-slot:item="props">
        <tr>
          <td class="text-xs-center text-no-wrap" v-if="!carId">
            <v-btn
              elevation="0"
              min-width="36"
              min-height="36"
              @click="
                $store.dispatch('garage/maintenanceParts', {
                  brand: props.item.brand,
                  link: props.item.levam_link,
                  car: props.item,
                });
                maintenancePartsForm = true;
              "
              :disabled="!props.item.maintenance_part_available"
              :title="$t('common.maintenance_parts')"
              color="secondary"
              class="ml-2 white--text px-0"
            >
              <v-icon small>$oils</v-icon>
            </v-btn>

            <v-btn
              elevation="0"
              min-width="36"
              min-height="36"
              :disabled="!props.item.levam_link || props.item.levam_link == -1 || props.item.levam_link.toString().length < 10"
              @click="toOEMWidget(props.item)"
              title="OEM"
              color="secondary"
              class="ml-2 white--text px-0"
              id="toOEMBtn"
            >
              <v-icon small>$oem</v-icon>
            </v-btn>
          </td>
          <td class="text-xs-left" v-if="carId">
            <v-simple-checkbox
              @click="
                tmpCarId = props.item.id === tmpCarId ? null : props.item.id
              "
              :value="props.item.id === tmpCarId"
            ></v-simple-checkbox>
          </td>
          <td class="text-xs-left">
            <v-btn
                elevation="0"
                min-width="36"
                min-height="36"
                color="primary"
                class="mb-0 ml-3 px-0 white--text"
                :title="$t('common.edit')"
                @click="
                carEditForm.isVisible = true;
                carEditForm.carId = props.item.id;
              "
            >
              <v-icon small>$pencil</v-icon>
            </v-btn>
          </td>
          <td class="text-xs-center">
            <img
              :src="props.item.image ? props.item.image : $imgDummyPath"
              height="35px"
            />
          </td>
          <td class="text-xs-left">
            {{ props.item.name }}
          </td>
          <td class="text-xs-left">
            <beauty-car-number
              :number="props.item.car_number ? props.item.car_number : ''"
            />
          </td>
          <td class="text-xs-left">
            {{ props.item.mileages[0] ? props.item.mileages[0].value : "" }}
          </td>
          <td class="text-xs-left">
            {{ props.item.brand }}<br/>
            {{ props.item.family }}<br/>
            {{ props.item.model }}<br/>
            {{ ! props.item.vin ? '' : '[' + props.item.vin + ']'}}
          </td>


        </tr>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
    </v-data-table>
    <div class="text-right">
      <v-divider v-if="tmpCar && tmpCar.link" class="my-5"></v-divider>
      <template v-if="carId && !showAddForm">
        <v-btn
            color="primary"
            elevation="0"
            class="white--text"
            @click="saveChoosedCar"
        >
          {{ $t("common.save") }}
        </v-btn>
      </template>
      <v-btn
        v-if="tmpCar && tmpCar.link"
        :disabled="savingInProgress"
        class="ma-2 mr-0 white--text"
        color="red"
        elevation="0"
        @click="closeForm"
      >
        {{ $t("common.cancel") }}
      </v-btn>
      <v-btn
        :disabled="!(parseInt(customerId) > 0) || savingInProgress"
        v-if="tmpCar && tmpCar.link"
        class="ma-2 ml-2 mr-0"
        color="primary"
        elevation="0"
        @click="saveCar()"
        id="saveCarBtn"
      >
        {{ $t("common.save") }}
        <span id="saveCarBtnPlaceholder"></span>
      </v-btn>
    </div>

    <v-dialog v-model="carEditForm.isVisible" scrollable max-width="890">
      <carForm :show="carEditForm.isVisible"
        @removed="carEditForm.isVisible=false"
        :car-id="carEditForm.carId"
        @store="onStoreCar"
      ></carForm>
    </v-dialog>
    <v-dialog v-model="maintenancePartsForm" scrollable max-width="90%">
      <maintenanceParts></maintenanceParts>
    </v-dialog>
    <div class="text-right"><span id="placeholderAddCar"></span></div>
  </div>
</template>
<script>
//import CarForm from "@/components/garage/CarForm.vue";
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import MaintenanceParts from "@/components/garage/MaintenanceParts.vue";
import BeautyCarNumber from "../common/BeautyCarNumber";
import CommonMixin from "@/mixins/common";
//import CarSelectorByApi from "@/components/common/CarSelectorByApi";

export default {
  name: "CustomerGarage",
  components: {
    BeautyCarNumber,
    CarSelectorByApi: () => import("@/components/common/CarSelectorByApi.vue"),
    CarForm: () => import("@/components/garage/CarForm.vue"),
    MaintenanceParts
  },
  mixins: [CommonMixin],
  props: {
    customerId: Number,
    carId: Number,
    visibilityStatus: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    maintenancePartsForm: false,
    id: null,
    customerEditFormTab: 0,
    showAddForm: false,
    paramsList: [],
    cars: [],
    tmpCar: null,
    carEditForm:{
      isVisible: false,
      carId: null
    }
  }),
  mounted() {
    this.onLoad();
  },
  watch: {
    visibilityStatus: function (newVal, oldVal) {
      this.clearForm();
    },
    async customerId(newVal, oldVal) {
      if(this.customerId) {
        this.cars = await this.$store.dispatch("garage/getCustomerCars", this.customerId);
      }
    },

  },
  computed: {
    ...mapFields("common", ["popularBrands"]),
    ...mapFields("garage", [
      "selectedModificationProps",
      "tmpCarId",
      "modifications",
      "families",
      "savingInProgress",
    ]),
    carsTableHeader() {
      let obj = [
        { text: "", value: "", sortable: false },
        { text: "", value: "", sortable: false },
        {
          text: this.$t("common.title"),
          value: "name",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.car_number"),
          value: "car_number",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.mileage"),
          value: "mileage",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.car"),
          value: "brand",
          sortable: true,
          class: "text-no-wrap",
        },
             ];
      if (!this.carId)
        obj.unshift({
          text: "",
          value: "maintenance_parts",
          sortable: true,
          class: "text-no-wrap",
        });
      if (this.carId)
        obj.unshift({
          text: this.$t("common.select"),
          value: "name",
          sortable: false,
        });
      return obj;
    },
  },
  methods: {
    async onStoreCar(){
        this.cars = await this.$store.dispatch('garage/getCustomerCars', customerId);
        this.carEditForm.isVisible = false;
    },
    saveChoosedCar() {
      let selectedCar = this.cars.filter((car) => {
        return car.id === this.tmpCarId;
      })[0];
      this.$emit("chooseCar", selectedCar);
    },
    chooseCar(car) {
      if (!car.vin) {
        this.$error(this.$t("windowFastOrder.error_no_car_vin"));
        return;
      }
      if (!car.car_number) {
        this.$error(this.$t("windowFastOrder.error_no_car_number"));
        return;
      }
      this.tmpCar = car;
    },
    async saveCar() {
      this.tmpCar.customer_id = this.customerId;
      await this.$store
        .dispatch("garage/store", this.tmpCar)
        .then(async () => {
          this.cars = await this.$store.dispatch("garage/getCustomerCars", this.customerId);
          this.$emit("store");
        })
        .then(() => {
          this.closeForm();
        });
    },
    clearForm() {
      if(this.showAddForm) {
        if(this.tmpCar) {
          this.tmpCar.link = null;
        }
        this.selectedModificationProps = null;
        this.modifications = [];
        this.families = [];
        this.selectedModificationProps = null;
        for (let i in this.tmpCar) {
          this.tmpCar[i] = null;
        }
        this.showAddForm = false;
      }
      this.tmpCar = null;
    },
    closeForm() {
      this.clearForm();
      this.$emit("close");
    },
    async onLoad() {
      this.showAddForm = false;
      await this.$store.dispatch("customer_types/get");
      if (this.customerId) {
        this.cars = await this.$store.dispatch("garage/getCustomerCars", this.customerId);
      }
    },
  },
};
</script>
<style lang="css" scoped>
.addToGarage {
  /*margin-top: -85px !important;*/
  /*position: absolute;*/
  /*right: 15px;*/
  /*margin-bottom: 0 !important;*/
}
</style>
